export const INITIAL_STATE = {
    banners: [
        {
            desktop_image_url: null,
            mobile_image_url: null,
        },
    ],
    products: [],
    vouchers: [],
}

export const GET_FIELD_NAME = {
    banners: 'Banners item',
    products: 'Product Highlight',
    vouchers: 'Voucher Highlight',
}

export const GET_ITEM_FIELD_NAME = {
    desktop_image_url: 'Image desktop',
    mobile_image_url: 'Image mobile',
}
